const sidebarItems = [
  {
    id: 1,
    title: "Introduction",
    url: "/",
  },
  {
    id: 2,
    title: "Publications",
    url: "/publications",
  },
  {
    id: 3,
    title: "Team Members",
    url: "/team-members",

    subMenu: [
      {
        id: 1,
        title: "Current Team Members",
        url: "/team-members/current-team-members",
      },
      {
        id: 2,
        title: "Lab Alumni",
        url: "/team-members/lab-alumni",
      },
    ],
  },

  {
    id: 4,
    title: "Projects",
    url: "/projects",
  },
  {
    id: 5,
    title: "News",
    url: "/news",
  },
  {
    id: 6,
    title: "Contact Us",
    url: "/contacts",
  },
  {
    id: 7,
    title: "Job Opportunity",
    url: "/job",
  },
];

export default sidebarItems;
